import { firestoreAction } from 'vuexfire'
import db from '../firebase'
import sha512 from "crypto-js/sha512";
// import { delete } from 'vue/types/umd';
const state = {
  members: [],
  member: null,
  loggedIn: false,
  nurseActivity: [],
  nurseActivityFetched:false,
  membersFetched:false,
  StartEndActivity: null
}
const getters = {
  members: (state) => {
    return state.members
  },
  loggedInmember: (state) => {
    return state.loggedIn
  },
  member: (state) => {
    return state.member
  },
  getActivity: (state) => {
    return state.StartEndActivity
  },
  nurseActivities: (state) => {
    return state.nurseActivity
  },
  nurseActivityFetched: (state) => {
    return state.nurseActivityFetched
  },
  membernames: (state) => {
    return state.members.map(members => members.name)
  },
  membersFetched: (state) => {
    return state.membersFetched
  },
  membernameandId: (state) => {
    return state.members.map(members => [members.name, members.id,members.name +"("+members.role+")"])
  },
  membersInfo: (state) => {
    return state.members.filter(m=> m.hasOwnProperty('description')).filter(m=> m.hasOwnProperty('workdays')).map(members =>( {description: members.description ,role: members.role, workdays: members.workdays , workinghours: members.workinghours , title: members.name +"("+members.role+")"}))
  }
  
}
const mutations={
  logout_eht(state){
    // // ("Logga ut eht")
    state.member=null;
    state.members=[]    
  state.nurseActivity =[],
  state.nurseActivityFetched=false;
  state.membersFetched=false;
    state.loggedIn=false;
      },
      update_member(state,member){
        // // ("Logga ut eht")
        state.member=member;
          }
}
const actions = {
  initEHT: firestoreAction(({ bindFirestoreRef ,state}, schoolId) => {
    bindFirestoreRef('members', db.collection('ehtmembers').where('schoolId', '==', schoolId)).then((res) => {
      state.membersFetched=true;
    })
  }),
  NurseActivityGet: firestoreAction(({ bindFirestoreRef, state }, schoolId) => {
    bindFirestoreRef('nurseActivity', db.collection('nursecheck').where('schoolId', '==', schoolId))
    .then((res) => {
   state.nurseActivityFetched=true
    })
  }),

  GetStartEnd: firestoreAction(({ bindFirestoreRef, state }, id) => {
    bindFirestoreRef('StartEndActivity', db.collection('nursecheck').doc(id))
    .then((res) => {
    // (state.nurseActivity)
    })
  }),

  removeActivity({},activityId){
    db.collection('nursecheck').doc(activityId).delete()
  },

  updatePlan({},student){
    if(student.Type=="update")
    student.updated=Date.now();
    delete student.Type;
    db.collection('nursecheck').doc(student.id).update(student)
  },
  nurseCheck({},student){
    student.time=  Date.now() 
    // (student)
    db.collection('nursecheck').add(
      student
    );
    //.doc(member.id).set(member.data);
  },

  logoutEHT ({commit}) {
    commit('logout_eht')
},

  loginmember({state},data){
    let loggedin=false;
    // state.loggedIn=false; //Test för att lösa problem
    let Member=null;
        db.collection("ehtmembers").where('mail', '==', data[0]).where('password', '==', sha512(data[1]).toString()).get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                Member=doc.data()
                  loggedin=true;
                  // state.loggedIn=loggedin;
                  // // (state.loggedIn)
                Member.id =doc.id
              })
            })
            .then(() => {

              state.loggedIn=loggedin;
              // // (loggedin)
              if (loggedin==true) {
                delete Member.newPassword;
                delete Member.password;
                state.member=Member
                Member.oldLastOnline=Member.lastOnline;
                Member.lastOnline=Date.now();
                db.collection('ehtmembers').doc(Member.id).update(Member)

              }
                return loggedin
            }) .catch((err) => {
               (err)
              state.loggedIn=loggedin;
            })
      },

  
  savemember({commit},member){
    
    commit('update_member',member)
    db.collection('ehtmembers').doc(member.id).update(member)
    
  },
  removemember({},memberId){
    db.collection('ehtmembers').doc(memberId).delete()
  },
  createmember({},member){
    member.lastOnline=  Date.now() 
    db.collection('ehtmembers').add(
      member
    );
    //.doc(member.id).set(member.data);
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
